/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_RoleInputs */

const th_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทบาท`)
};

const en_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role`)
};

const ja_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`役割`)
};

const zh_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色`)
};

const es_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rol`)
};

const pt_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Função`)
};

const id_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peran`)
};

const fr_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rôle`)
};

const tl_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tungkulin`)
};

const vi_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai trò`)
};

const ko_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`역할`)
};

const de_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolle`)
};

const ru_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роль`)
};

const tr_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rol`)
};

const it_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruolo`)
};

const pl_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rola`)
};

const uk_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роль`)
};

const hi_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भूमिका`)
};

const ar_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدور`)
};

const ms_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peranan`)
};

const bn_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভূমিকা`)
};

const zh_tw2_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色`)
};

const zh_hk2_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色`)
};

const ur_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کردار`)
};

const fa_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نقش`)
};

const sw_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nafasi`)
};

const nl_org_role = /** @type {(inputs: Org_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rol`)
};

/**
* | output |
* | --- |
* | "Role" |
*
* @param {Org_RoleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_role = /** @type {((inputs?: Org_RoleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_RoleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_role(inputs)
	if (locale === "ja") return ja_org_role(inputs)
	if (locale === "zh") return zh_org_role(inputs)
	if (locale === "es") return es_org_role(inputs)
	if (locale === "pt") return pt_org_role(inputs)
	if (locale === "id") return id_org_role(inputs)
	if (locale === "fr") return fr_org_role(inputs)
	if (locale === "tl") return tl_org_role(inputs)
	if (locale === "vi") return vi_org_role(inputs)
	if (locale === "ko") return ko_org_role(inputs)
	if (locale === "de") return de_org_role(inputs)
	if (locale === "ru") return ru_org_role(inputs)
	if (locale === "tr") return tr_org_role(inputs)
	if (locale === "it") return it_org_role(inputs)
	if (locale === "pl") return pl_org_role(inputs)
	if (locale === "uk") return uk_org_role(inputs)
	if (locale === "hi") return hi_org_role(inputs)
	if (locale === "ar") return ar_org_role(inputs)
	if (locale === "ms") return ms_org_role(inputs)
	if (locale === "bn") return bn_org_role(inputs)
	if (locale === "zh-TW") return zh_tw2_org_role(inputs)
	if (locale === "zh-HK") return zh_hk2_org_role(inputs)
	if (locale === "ur") return ur_org_role(inputs)
	if (locale === "fa") return fa_org_role(inputs)
	if (locale === "sw") return sw_org_role(inputs)
	if (locale === "nl") return nl_org_role(inputs)
	return en_org_role(inputs)
});